import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, viewportOnce } from "../../lib/motion";
import { trackEvent } from "../../lib/seo";

const ProClosing = () => (
    <section
        data-testid="pro-closing-section"
        className="relative py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="max-w-4xl"
            >
                <p className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-pro-steel-light">
                    <span className="h-1.5 w-1.5 bg-accent" />
                    CLARITY. INTELLIGENCE. CONFIDENCE. OPPORTUNITY.
                </p>
                <h2
                    data-testid="pro-closing-headline"
                    className="mt-8 font-display text-3xl font-semibold leading-[1.12] text-pro-platinum md:text-5xl"
                >
                    BuildEase is developing something valuable for the
                    construction and property industry
                    <span className="text-accent">.</span>
                </h2>
                <p className="mt-6 max-w-2xl text-[16px] leading-relaxed text-pro-steel-light">
                    Explore how the platform supports homeowners today, and
                    position your expertise within the professional ecosystem
                    as it develops.
                </p>
                <div className="mt-10 flex flex-wrap gap-4">
                    <a
                        href="#pro-enquiry"
                        data-testid="pro-closing-network"
                        onClick={() =>
                            trackEvent("pro_pathway_click", "pro_closing")
                        }
                        className="inline-flex items-center border border-pro-steel px-6 py-4 text-[16px] font-medium text-pro-platinum transition-colors duration-300 hover:border-accent"
                    >
                        Join the Professional Network
                    </a>
                    <Link
                        to="/product"
                        data-testid="pro-closing-platform"
                        className="group inline-flex items-center gap-2 text-[15px] font-semibold text-accent transition-colors duration-300 hover:text-[#ff7026]"
                    >
                        Explore the Homeowner Platform
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                </div>
            </motion.div>
        </div>
    </section>
);

export default ProClosing;
